import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/contexts/LanguageContext";
import LandingPage from "@/pages/LandingPage";
import CuriosityPage from "@/pages/CuriosityPage";
import ChatPage from "@/pages/ChatPage";
import AdminPage from "@/pages/AdminPage";
import LegalPage from "@/pages/LegalPage";
import PersonalityTestPage from "@/pages/PersonalityTestPage";
import InfluencerLoginPage from "@/pages/InfluencerLoginPage";
import InfluencerRegisterPage from "@/pages/InfluencerRegisterPage";
import InfluencerDashboardPage from "@/pages/InfluencerDashboardPage";
import AffiliatePage from "@/pages/AffiliatePage";

function App() {
  return (
    <LanguageProvider>
      <div className="App min-h-screen bg-white">
        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              background: '#FFFFFF',
              border: '1px solid #ECECEC',
              color: '#111111',
              boxShadow: '0 8px 30px rgba(0,0,0,0.08)',
              borderRadius: '16px',
            },
          }}
        />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/reading" element={<CuriosityPage />} />
            <Route path="/chat/:sessionId" element={<ChatPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/legal/:page" element={<LegalPage />} />
            <Route path="/test/:testType" element={<PersonalityTestPage />} />
            <Route path="/influencer/login" element={<InfluencerLoginPage />} />
            <Route path="/influencer/register" element={<InfluencerRegisterPage />} />
            <Route path="/influencer/dashboard" element={<InfluencerDashboardPage />} />
            <Route path="/affiliate" element={<AffiliatePage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
